import { render } from "./UpcomingInterviews.vue?vue&type=template&id=391ed125"
import script from "./UpcomingInterviews.vue?vue&type=script&lang=js"
export * from "./UpcomingInterviews.vue?vue&type=script&lang=js"

import "./UpcomingInterviews.vue?vue&type=style&index=0&id=391ed125&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__